import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	logIn: {
		id: `JoinSiteUserDropdown.logIn`,
		defaultMessage: 'Sign in',
	},
	logInAlternative: {
		id: `JoinSiteUserDropdown.logInAlternative`,
		defaultMessage: 'Log in',
	},
	joinTeam: {
		id: `JoinSiteUserDropdown.joinTeam`,
		defaultMessage: 'Find my team',
	},
	profile: {
		id: `JoinSiteUserDropdown.profile`,
		defaultMessage: 'Profile',
	},
	licenses: {
		id: `JoinSiteUserDropdown.licenses`,
		defaultMessage: 'Licenses',
	},
	logOut: {
		id: `JoinSiteUserDropdown.logOut`,
		defaultMessage: 'Log out',
	},
	logOutTriggerText: {
		id: `JoinSiteUserDropdown.logOutTriggerText`,
		defaultMessage: 'My account',
	},
	switchAccount: {
		id: `JoinSiteUserDropdown.switchAccount`,
		defaultMessage: 'Switch Account',
	},
});
